import React from 'react';

export function SegmentedTabs({ value, onChange, options, testIdPrefix = 'tabs', size = 'md' }) {
    const pad = size === 'sm' ? 'px-3 py-1.5' : 'px-3.5 py-2';
    return (
        <div className="inline-flex items-center gap-1 p-1 rounded-xl bg-[var(--brand-rose)]/60 max-w-full overflow-x-auto" data-testid={`${testIdPrefix}-bar`}>
            {options.map((o) => {
                const active = value === o.key;
                return (
                    <button
                        key={o.key}
                        onClick={() => onChange(o.key)}
                        data-testid={`${testIdPrefix}-${o.key}`}
                        className={`${pad} rounded-lg text-xs uppercase tracking-[0.14em] whitespace-nowrap transition-colors inline-flex items-center gap-1.5 ${
                            active ? 'bg-[var(--brand-burgundy)] text-white shadow-sm' : 'text-[var(--brand-burgundy)] hover:bg-white/60'
                        }`}
                    >
                        <span>{o.label}</span>
                        {o.count != null && (
                            <span className={`text-[10px] px-1.5 rounded-full ${active ? 'bg-white/25' : 'bg-[var(--brand-burgundy)]/10'}`}>{o.count}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
